import React from 'react'
import { renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { Module } from '../../../../helpers/types'
import { CarouselTextAreasWithAccount } from '../../CarouselTextAreasWithAccount'
import { timestamp } from '../../staticText'
import { TextAreaWithAccountName } from '../../TextAreaWithAccountName'
import { CarouselIndexWheel } from './CarouselIndexWheel'
import { styles } from './styles'

export interface Props {
  accountUsername: string
  content: string
  contentCharacterLimit: number
  contentPlaceholderText: string
  cta?: string
  ctaUrl?: string
  description?: string
  effect?: string
  headline?: string
  index?: number
  isPresenting: boolean
  modules: Module[]
  onContentChange: (val: string, dest: string) => void
  postType: string
  readOnly: boolean
  truncate: boolean
}

export const MobileStreamFooter: React.FC<Props> = ({
  accountUsername,
  content,
  contentCharacterLimit,
  contentPlaceholderText,
  cta,
  ctaUrl,
  effect,
  headline,
  index,
  isPresenting,
  modules,
  onContentChange,
  postType,
  readOnly,
  truncate,
}) => {
  const getContentFields = (postType: string) => {
    if (postType.includes('carousel')) {
      return (
        <CarouselTextAreasWithAccount
          content={content}
          index={index || 0}
          contentCharacterLimit={contentCharacterLimit}
          headline={headline || ''}
          onContentChange={onContentChange}
          readOnly={readOnly}
          postType={postType}
          username={accountUsername}
          truncate={truncate}
        />
      )
    } else {
      return (
        <TextAreaWithAccountName
          postType={postType}
          content={content}
          display="mobileStream"
          readOnly={readOnly}
          isPresenting={isPresenting}
          placeholder={contentPlaceholderText}
          contentCharacterLimit={contentCharacterLimit}
          style={styles.getInput(false)}
          onContentChange={(val: string) => onContentChange(val, 'content')}
          accountMeasurerStyle={styles.accountMeasurer}
          truncate={truncate}
          truncationLimit={80}
          username={accountUsername}
        />
      )
    }
  }

  return (
    <div
      css={styles.footerWrapper}
      className={kuiperClassNames('instagram-stream-footer')}
    >
      {postType.includes('ad') && (
        <div css={styles.ctaWrapper}>
          {!ctaUrl
            ? 'No Website URL Entered Yet'
            : cta || 'No CTA Selected Yet'}
          {renderIcon('instagram-mobile-cta-chevron', { ariaMode: 'hidden' })}
        </div>
      )}
      <ul css={styles.responseList}>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderIcon('instagram-mobile-heart', { ariaMode: 'hidden' })}
        </li>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderIcon('instagram-mobile-comment', { ariaMode: 'hidden' })}
        </li>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderIcon('instagram-mobile-send', { ariaMode: 'hidden' })}
        </li>
        <li css={styles.responseItem({ bookmark: true })}>
          {renderIcon('instagram-mobile-bookmark', { ariaMode: 'hidden' })}
        </li>
      </ul>
      {postType.includes('carousel') && (
        <CarouselIndexWheel index={index || 0} modules={modules || []} />
      )}
      <div css={styles.contentWrapper}>{getContentFields(postType)}</div>
      <div
        css={styles.postedAt}
        className={kuiperClassNames('instagram-posted-at')}
      >
        <span>{timestamp}</span>
        {effect && (
          <React.Fragment>
            <span css={styles.effectSeparatorStyles}>•</span>
            <span>Made with </span>
            <span css={styles.effectStyles}>Effect</span>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
